export default __webpack_public_path__ + "static/media/843.04e6626c.png";